// dummyData.ts
export const dummyData = [
  {
    serialNumber: 10,
    project_id : "CF010",
    ritm: "RITM6658529",
    capability: "Yes",
    bandwidth: "Yes",
    benchmarking: "Yes",
    projectLead: "Jane Smith",
    stakeholder: "Sales",
    financeLead: "Sara White",
    costCenter: "England",
    sector: "Finance",
    geographicScope: "England",
    newOrExtension: "Yes",
    projectName: "Project A",
    projectBrief: "Project A description",
    consultingType: "Strategy",
    projectStartDate: "2024-09-17",
    projectEndDate: "2024-09-26",
    preferredVendors: "vendor Y",
    deliverables: "dummy values",
    specialRequirements: "nothing",
    requestedBy: "John Doe",
    location: "New York Office",
    manager: "Jane Smith",
    email: "john.doe@example.com",
    financeEmail: "david.brown@finance.com",
    consultingCompany: "Company A",
    valueReceivedRating: "N/A",
    finalCostUSD: "N/A",
    dataClassification: "N/A",
    purchaseOrderNumber: "N/A",
    opportunityCost: "N/A",
    finalDeliverables: "N/A",
    followUpWork: "N/A",
    supportingDocuments: [],
  },
  {
    serialNumber: 9,
    project_id : "CF009",
    ritm: "N/A",
    capability: "Yes",
    bandwidth: "Yes",
    benchmarking: "Yes",
    projectLead: "John Doe",
    stakeholder: "Marketing",
    financeLead: "David Brown",
    costCenter: "India",
    sector: "Technology",
    geographicScope: "India",
    newOrExtension: "Yes",
    projectName: "Project B",
    projectBrief: "Project B Description",
    consultingType: "Advisory",
    projectStartDate: "2024-09-16",
    projectEndDate: "2024-09-25",
    preferredVendors: "Vendor X",
    deliverables: "Testing data",
    specialRequirements: "N/A",
    requestedBy: "John Doe",
    location: "New York Office",
    manager: "Jane Smith",
    email: "john.doe@example.com",
    financeEmail: "david.brown@finance.com",
    consultingCompany: "Tiger Analytics",
    valueReceivedRating: "N/A",
    finalCostUSD: "N/A",
    dataClassification: "N/A",
    purchaseOrderNumber: "N/A",
    opportunityCost: "N/A",
    finalDeliverables: "N/A",
    followUpWork: "N/A",
    supportingDocuments: [],
  },
  {
    serialNumber: 8,
    project_id : "CF008",
    ritm: "RITM6658525",
    capability: "Yes",
    bandwidth: "Yes",
    benchmarking: "Yes",
    projectLead: "Jane Smith",
    stakeholder: "Sales",
    financeLead: "Sara White",
    costCenter: "England",
    sector: "Finance",
    geographicScope: "England",
    newOrExtension: "Yes",
    projectName: "Project C",
    projectBrief: "Project C description",
    consultingType: "Strategy",
    projectStartDate: "2024-09-17",
    projectEndDate: "2024-09-26",
    preferredVendors: "vendor Y",
    deliverables: "dummy values",
    specialRequirements: "nothing",
    requestedBy: "John Doe",
    location: "New York Office",
    manager: "Jane Smith",
    email: "john.doe@example.com",
    financeEmail: "david.brown@finance.com",
    consultingCompany: "Company B",
    valueReceivedRating: "N/A",
    finalCostUSD: "N/A",
    dataClassification: "N/A",
    purchaseOrderNumber: "N/A",
    opportunityCost: "N/A",
    finalDeliverables: "N/A",
    followUpWork: "N/A",
    supportingDocuments: [],
  },
  {
    serialNumber: 7,
    project_id : "CF007",
    ritm: "N/A",
    capability: "Yes",
    bandwidth: "Yes",
    benchmarking: "Yes",
    projectLead: "John Doe",
    stakeholder: "Marketing",
    financeLead: "David Brown",
    costCenter: "India",
    sector: "Technology",
    geographicScope: "India",
    newOrExtension: "Yes",
    projectName: "Project D",
    projectBrief: "Project D Description",
    consultingType: "Advisory",
    projectStartDate: "2024-09-16",
    projectEndDate: "2024-09-25",
    preferredVendors: "Vendor X",
    deliverables: "Testing data",
    specialRequirements: "N/A",
    requestedBy: "John Doe",
    location: "New York Office",
    manager: "Jane Smith",
    email: "john.doe@example.com",
    financeEmail: "david.brown@finance.com",
    consultingCompany: "Tiger Analytics",
    valueReceivedRating: "N/A",
    finalCostUSD: "N/A",
    dataClassification: "N/A",
    purchaseOrderNumber: "N/A",
    opportunityCost: "N/A",
    finalDeliverables: "N/A",
    followUpWork: "N/A",
    supportingDocuments: [],
  },
    {
      serialNumber: 6,
      project_id : "CF006",
      ritm: "RITM6658522",
      capability: "Yes",
      bandwidth: "Yes",
      benchmarking: "Yes",
      projectLead: "Jane Smith",
      stakeholder: "Sales",
      financeLead: "Sara White",
      costCenter: "England",
      sector: "Finance",
      geographicScope: "England",
      newOrExtension: "Yes",
      projectName: "Project E",
      projectBrief: "Project E description",
      consultingType: "Strategy",
      projectStartDate: "2024-09-17",
      projectEndDate: "2024-09-26",
      preferredVendors: "vendor Y",
      deliverables: "dummy values",
      specialRequirements: "nothing",
      requestedBy: "John Doe",
      location: "New York Office",
      manager: "Jane Smith",
      email: "john.doe@example.com",
      financeEmail: "david.brown@finance.com",
      consultingCompany: "Company C",
      valueReceivedRating: "N/A",
      finalCostUSD: "N/A",
      dataClassification: "N/A",
      purchaseOrderNumber: "N/A",
      opportunityCost: "N/A",
      finalDeliverables: "N/A",
      followUpWork: "N/A",
      supportingDocuments: [],
    },
    {
      serialNumber: 5,
      project_id : "CF005",
      ritm: "N/A",
      capability: "Yes",
      bandwidth: "Yes",
      benchmarking: "Yes",
      projectLead: "John Doe",
      stakeholder: "Marketing",
      financeLead: "David Brown",
      costCenter: "India",
      sector: "Technology",
      geographicScope: "India",
      newOrExtension: "Yes",
      projectName: "Project F",
      projectBrief: "Project F Description",
      consultingType: "Advisory",
      projectStartDate: "2024-09-16",
      projectEndDate: "2024-09-25",
      preferredVendors: "Vendor X",
      deliverables: "Testing data",
      specialRequirements: "N/A",
      requestedBy: "John Doe",
      location: "New York Office",
      manager: "Jane Smith",
      email: "john.doe@example.com",
      financeEmail: "david.brown@finance.com",
      consultingCompany: "Company D",
      valueReceivedRating: "N/A",
      finalCostUSD: "N/A",
      dataClassification: "N/A",
      purchaseOrderNumber: "N/A",
      opportunityCost: "N/A",
      finalDeliverables: "N/A",
      followUpWork: "N/A",
      supportingDocuments: [],
    },
  {
    serialNumber: 4,
    project_id : "CF004",
    ritm: "RITM6658521",
    capability: "Yes",
    bandwidth: "Yes",
    benchmarking: "Yes",
    projectLead: "Jane Smith",
    stakeholder: "Sales",
    financeLead: "Sara White",
    costCenter: "England",
    sector: "Finance",
    geographicScope: "England",
    newOrExtension: "Yes",
    projectName: "Project G",
    projectBrief: "Project G description",
    consultingType: "Strategy",
    projectStartDate: "2024-09-17",
    projectEndDate: "2024-09-26",
    preferredVendors: "vendor Y",
    deliverables: "dummy values",
    specialRequirements: "nothing",
    requestedBy: "John Doe",
    location: "New York Office",
    manager: "Jane Smith",
    email: "john.doe@example.com",
    financeEmail: "david.brown@finance.com",
    consultingCompany: "Company E",
    valueReceivedRating: "N/A",
    finalCostUSD: "N/A",
    dataClassification: "N/A",
    purchaseOrderNumber: "N/A",
    opportunityCost: "N/A",
    finalDeliverables: "N/A",
    followUpWork: "N/A",
    supportingDocuments: [],
  },
  {
    serialNumber: 3,
    project_id : "CF003",
    ritm: "N/A",
    capability: "Yes",
    bandwidth: "Yes",
    benchmarking: "Yes",
    projectLead: "John Doe",
    stakeholder: "Marketing",
    financeLead: "David Brown",
    costCenter: "India",
    sector: "Technology",
    geographicScope: "India",
    newOrExtension: "Yes",
    projectName: "Project H",
    projectBrief: "Project H Description",
    consultingType: "Advisory",
    projectStartDate: "2024-09-16",
    projectEndDate: "2024-09-25",
    preferredVendors: "Vendor X",
    deliverables: "Testing data",
    specialRequirements: "N/A",
    requestedBy: "John Doe",
    location: "New York Office",
    manager: "Jane Smith",
    email: "john.doe@example.com",
    financeEmail: "david.brown@finance.com",
    consultingCompany: "Company A",
    valueReceivedRating: "N/A",
    finalCostUSD: "N/A",
    dataClassification: "N/A",
    purchaseOrderNumber: "N/A",
    opportunityCost: "N/A",
    finalDeliverables: "N/A",
    followUpWork: "N/A",
    supportingDocuments: [],
  },
    {
      serialNumber: 2,
      project_id : "CF002",
      ritm: "RITM6658518",
      capability: "Yes",
      bandwidth: "Yes",
      benchmarking: "Yes",
      projectLead: "Jane Smith",
      stakeholder: "Sales",
      financeLead: "Sara White",
      costCenter: "England",
      sector: "Finance",
      geographicScope: "England",
      newOrExtension: "Yes",
      projectName: "Project I",
      projectBrief: "Project I Description",
      consultingType: "Strategy",
      projectStartDate: "2024-09-17",
      projectEndDate: "2024-09-26",
      preferredVendors: "vendor Y",
      deliverables: "dummy values",
      specialRequirements: "nothing",
      requestedBy: "John Doe",
      location: "New York Office",
      manager: "Jane Smith",
      email: "john.doe@example.com",
      financeEmail: "david.brown@finance.com",
      consultingCompany: "Company B",
      valueReceivedRating: "N/A",
      finalCostUSD: "N/A",
      dataClassification: "N/A",
      purchaseOrderNumber: "N/A",
      opportunityCost: "N/A",
      finalDeliverables: "N/A",
      followUpWork: "N/A",
      supportingDocuments: [],
    },
    {
      serialNumber: 1,
      project_id : "CF001",
      ritm: "N/A",
      capability: "Yes",
      bandwidth: "Yes",
      benchmarking: "Yes",
      projectLead: "John Doe",
      stakeholder: "Marketing",
      financeLead: "David Brown",
      costCenter: "India",
      sector: "Technology",
      geographicScope: "India",
      newOrExtension: "Yes",
      projectName: "Project J",
      projectBrief: "Project J Description",
      consultingType: "Advisory",
      projectStartDate: "2024-01-16",
      projectEndDate: "2024-09-25",
      preferredVendors: "Vendor X",
      deliverables: "Testing data",
      specialRequirements: "N/A",
      requestedBy: "John Doe",
      location: "New York Office",
      manager: "Jane Smith",
      email: "john.doe@example.com",
      financeEmail: "david.brown@finance.com",
      consultingCompany: "Company C",
      valueReceivedRating: "N/A",
      finalCostUSD: "N/A",
      dataClassification: "N/A",
      purchaseOrderNumber: "N/A",
      opportunityCost: "N/A",
      finalDeliverables: "N/A",
      followUpWork: "N/A",
      supportingDocuments: [],
    },
    {
      serialNumber: 10,
      project_id : "CF010",
      ritm: "RITM6658529",
      capability: "Yes",
      bandwidth: "Yes",
      benchmarking: "Yes",
      projectLead: "Jane Smith",
      stakeholder: "Sales",
      financeLead: "Sara White",
      costCenter: "England",
      sector: "Finance",
      geographicScope: "England",
      newOrExtension: "Yes",
      projectName: "Project A",
      projectBrief: "Project A description",
      consultingType: "Strategy",
      projectStartDate: "2024-09-17",
      projectEndDate: "2024-09-26",
      preferredVendors: "vendor Y",
      deliverables: "dummy values",
      specialRequirements: "nothing",
      requestedBy: "John Doe",
      location: "New York Office",
      manager: "Jane Smith",
      email: "john.doe@example.com",
      financeEmail: "david.brown@finance.com",
      consultingCompany: "Company A",
      valueReceivedRating: "N/A",
      finalCostUSD: "N/A",
      dataClassification: "N/A",
      purchaseOrderNumber: "N/A",
      opportunityCost: "N/A",
      finalDeliverables: "N/A",
      followUpWork: "N/A",
      supportingDocuments: [],
    },
    {
      serialNumber: 9,
      project_id : "CF009",
      ritm: "N/A",
      capability: "Yes",
      bandwidth: "Yes",
      benchmarking: "Yes",
      projectLead: "John Doe",
      stakeholder: "Marketing",
      financeLead: "David Brown",
      costCenter: "India",
      sector: "Technology",
      geographicScope: "India",
      newOrExtension: "Yes",
      projectName: "Project B",
      projectBrief: "Project B Description",
      consultingType: "Advisory",
      projectStartDate: "2024-09-16",
      projectEndDate: "2024-09-25",
      preferredVendors: "Vendor X",
      deliverables: "Testing data",
      specialRequirements: "N/A",
      requestedBy: "John Doe",
      location: "New York Office",
      manager: "Jane Smith",
      email: "john.doe@example.com",
      financeEmail: "david.brown@finance.com",
      consultingCompany: "Tiger Analytics",
      valueReceivedRating: "N/A",
      finalCostUSD: "N/A",
      dataClassification: "N/A",
      purchaseOrderNumber: "N/A",
      opportunityCost: "N/A",
      finalDeliverables: "N/A",
      followUpWork: "N/A",
      supportingDocuments: [],
    },
    {
      serialNumber: 8,
      project_id : "CF008",
      ritm: "RITM6658525",
      capability: "Yes",
      bandwidth: "Yes",
      benchmarking: "Yes",
      projectLead: "Jane Smith",
      stakeholder: "Sales",
      financeLead: "Sara White",
      costCenter: "England",
      sector: "Finance",
      geographicScope: "England",
      newOrExtension: "Yes",
      projectName: "Project C",
      projectBrief: "Project C description",
      consultingType: "Strategy",
      projectStartDate: "2024-09-17",
      projectEndDate: "2024-09-26",
      preferredVendors: "vendor Y",
      deliverables: "dummy values",
      specialRequirements: "nothing",
      requestedBy: "John Doe",
      location: "New York Office",
      manager: "Jane Smith",
      email: "john.doe@example.com",
      financeEmail: "david.brown@finance.com",
      consultingCompany: "Company B",
      valueReceivedRating: "N/A",
      finalCostUSD: "N/A",
      dataClassification: "N/A",
      purchaseOrderNumber: "N/A",
      opportunityCost: "N/A",
      finalDeliverables: "N/A",
      followUpWork: "N/A",
      supportingDocuments: [],
    },
    {
      serialNumber: 7,
      project_id : "CF007",
      ritm: "N/A",
      capability: "Yes",
      bandwidth: "Yes",
      benchmarking: "Yes",
      projectLead: "John Doe",
      stakeholder: "Marketing",
      financeLead: "David Brown",
      costCenter: "India",
      sector: "Technology",
      geographicScope: "India",
      newOrExtension: "Yes",
      projectName: "Project D",
      projectBrief: "Project D Description",
      consultingType: "Advisory",
      projectStartDate: "2024-09-16",
      projectEndDate: "2024-09-25",
      preferredVendors: "Vendor X",
      deliverables: "Testing data",
      specialRequirements: "N/A",
      requestedBy: "John Doe",
      location: "New York Office",
      manager: "Jane Smith",
      email: "john.doe@example.com",
      financeEmail: "david.brown@finance.com",
      consultingCompany: "Tiger Analytics",
      valueReceivedRating: "N/A",
      finalCostUSD: "N/A",
      dataClassification: "N/A",
      purchaseOrderNumber: "N/A",
      opportunityCost: "N/A",
      finalDeliverables: "N/A",
      followUpWork: "N/A",
      supportingDocuments: [],
    },
  ];
  